// Wholesale WhatsApp Notification Service using CallMeBot via Cloud Functions

const CLOUD_FUNCTION_URL = 'https://us-central1-greycoffee-f7f71.cloudfunctions.net/sendWholesaleOrderNotification';

export const sendWholesaleOrderNotification = async (orderData) => {
  try {
    console.log('Sending wholesale order notification for order:', orderData.orderId);
    
    // Make the API call to Cloud Function
    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderData: orderData
      })
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send wholesale order notification');
    }

    const data = await response.json();
    console.log('Wholesale order WhatsApp notification sent successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error sending wholesale order WhatsApp notification:', error);
    throw error;
  }
};

export const testWholesaleNotification = async () => {
  try {
    // Create a test wholesale order
    const testOrder = {
      orderId: 'TEST-ORDER-123',
      customerName: 'Test Business LLC',
      contactPerson: 'John Doe',
      phone: '+974 1234 5678',
      email: 'test@business.com',
      paymentMethod: 'Cash on Delivery',
      items: [
        {
          name: 'Colombian Supremo',
          quantity: 2,
          wholesalePrice: 45.00
        },
        {
          name: 'Ethiopian Yirgacheffe',
          quantity: 1,
          wholesalePrice: 52.00
        }
      ],
      total: 142.00
    };

    const response = await fetch(CLOUD_FUNCTION_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        orderData: testOrder
      })
    });
    
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.error || 'Failed to send test wholesale notification');
    }

    const data = await response.json();
    console.log('Test wholesale WhatsApp notification sent successfully:', data);
    return data;
    
  } catch (error) {
    console.error('Error sending test wholesale notification:', error);
    throw error;
  }
};